// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"234":"d1a9b18a","353":"7a5d22f2"}[chunkId] + ".js";
};